import { useEffect, useRef, useState } from "react";

export  const useInfiniteScroll = (onLoadMore, hasMore, loading) => {
  const loaderRef = useRef(null);

  useEffect(() => {
    if (!loaderRef.current || !hasMore || loading) return;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          onLoadMore();
        }
      },
      { threshold: 1.0 }
    );

    observer.observe(loaderRef.current);

    return () => {
      if (loaderRef.current) observer.unobserve(loaderRef.current);
    };
  }, [hasMore, loading, onLoadMore]);

  return loaderRef;
};
